<template>
    <section class="container">      
      <div id="header-register-confirming">
        <img border="0" alt="Eurocaja Rural" src="../assets/img/logoEurocaja.png" height="35">
      </div>        
      <hr color = "#327e81" size="1"> 
      <div class="wide-window">
      <div class="mensajeError" v-if="confirmacion=='KO'">
        <p>cancel</p>
        <h3>{{mensajeError}}</h3>
      </div>
        <div class="registerContent">
          <div class="tableRegister">
            <p>
              Bienvenido al servicio de Rural Confirming. A continuación le mostramos los datos relacionados con la referencia que ha indicado. 
              Descargue el contrato adjunto y siga las instrucciones detalladas en el mismo para realizar
              el alta.
            </p>
            <md-table v-model="user">
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell><span class="cabeceraVertical">{{ item.id }}</span></md-table-cell>
                <md-table-cell>{{ item.name }}</md-table-cell>
              </md-table-row>
            </md-table>
            <hr/>
            <p id="subTextRegister">
              Esto son los datos que obran en nuestra base de datos proporcionados por su cliente, compruebe 
              que son correctos. Si detecta que algún dato es erróneo, hágalo saber en el teléfono de atención
              al cliente 952 269 644.
            </p>
            <input class="btnSecondary" type="button" value="Volver" @click="volver" v-if="confirmacion=='OK'">
          </div>
          <div class="downloadContract">
            <div class="pdfIcon">
              <img src="../assets/img/pdf-icon.png" alt="Descarga pdf">
            </div>
            <button @click="downloadPdf" :disabled="confirmacion=='OK'" class="btnPrimary downloadButton">Descargar Contrato</button>
          </div>
        </div>
      </div>
    </section>
</template>

<script>
import download from 'downloadjs';
export default {
    name : 'RegisterConfirmingComponent',
    data(){
      return{
        user: [
        {
          id: 'NIF/CIF',
          name: this.$route.params.datosContrato.holderLegalId
        },
        {
          id: 'Nombre y apellidos/Razón Social',
          name: this.$route.params.datosContrato.contractName
        },
        {
          id: 'Dirección completa',
          name: this.$route.params.datosContrato.address
        },
        {
          id: 'Teléfono móvil',
          name: this.$route.params.datosContrato.phone
        },
        {
          id: 'Email',
          name: this.$route.params.datosContrato.email
        }
      ],
      confirmacion:null,
      mensajeError:'Algo ha ido mal, asegúrate que has introducido correctamente tus datos', //mensaje de error por defecto
        submitted: false //nuestro model contiene los datos de Entrada, es como el modelCriteria de TF
      }
    },
    methods: {
      aceptar() {
        this.submitted = true;
          this.$v.$touch();
          if(this.$v.$invalid) {
            return false;
          }else {
            alert("Validación correcta"); //se reemplazara en un futuro con la llamada al servicio
          }
      },
      volver(){
        this.$router.push('/identificacion');
      },
      downloadPdf() { //en esta llamada habra que meter un token o algo para que nos autorice
        const ventana=this;
        var idgdoc='37ec90bc-f183-4a09-8487-2935550e5a0c'; //el de eurocaja PRO por defecto por si la parametrizacion no funciona
        this.$http.defaults.headers.common['X-USER-PROFILE-ID'] = this.$route.params.datosContrato.id; //necesario para que la llamada funcione
        switch(location.origin){
          case 'http://localhost:8080':{ //local
            idgdoc='cd88885a-ec08-4fbc-8011-dad4a591d4cc';
            break;
          }
          case 'https://10.31.18.15':{ //desa prod
            idgdoc='cd88885a-ec08-4fbc-8011-dad4a591d4cc';
            break;
          }
          case 'https://10.31.132.5':{ //ec pre
            idgdoc='ece9a4b4-f467-40d6-93d9-20b8d0ff60bc';
            break;
          }
          case 'https://onesaitportal.eurocajarural.es':{ //ec pro
            //idgdoc='680c6ff9-e71b-45b8-b3ec-de8cf611232b';
            idgdoc='37ec90bc-f183-4a09-8487-2935550e5a0c';
            break;
          }
        }
        const baseURI = '/api-documents/documents/'+idgdoc;
        this.llamada = {
          urlEndpoint : baseURI,
          metodo : 'GET'
        };        
        let loader = this.$loading.show();
        this.$http.get(baseURI, {responseType: 'blob'})
        .then((result) => {
          const content = result.headers['content-type'];
          if(download(result.data, "documentoContractualRuralConfirming", content)){ //si la descarga va bien
            var blob = new Blob([result.data], { type: 'application/pdf' });
            var url = window.URL.createObjectURL(blob);
            window.open(url); //abrimos el pdf
            //reseteamos valores que pudieran dar conflicto en otras operativas
            this.$http.defaults.headers.common['Authorization'] = null;
            this.$http.defaults.headers.common['X-USER-PROFILE-ID'] = null;
            this.confirmacion = "OK";
          }
        })
        .catch(error => {
          var codError = null;
          var descError = null;
          if(error.response){ 
            if(error.response.status != 200) {
                if(error.response.data.result) {
                  codError = error.response.data.result.errors[0].errorCode;
                  descError = error.response.data.result.errors[0].errorDescription;
                  ventana.mensajeError = codError + " - " + descError;
                } else {
                  codError = error.response.data.error;
                  descError = error.response.data.error_description;
                }
                ventana.confirmacion = "KO";
                window.scroll({
                  top: 0,
                  left: 0,
                  behavior: 'smooth'
                });
              
            }
          }else{ //si no, por defecto
            ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
            ventana.confirmacion='KO';
          }
        })
        .then(function () {
          loader.hide();
        });
      }
    }
}
</script>